import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setLinksEncuestasRedux,
  setLinksSurveysForSelect,
  setLinksUsersForSelect,
  storeLinkEncuestaDetailRedux,
  setLinksShareTemplatesForSelect,
} from './LinksEncuestasSlice';
import {
  getLinksEncuestasService,
  getLinksEncuestasBySearchService,
  createLinkEncuestaService,
  getLinkEncuestaDetailService,
  updateLinkEncuestaService,
  deleteLinkEncuestaService,
  restoreLinkEncuestaService,
} from '../../services/linksEncuestas.service';

export const startGetLinksEncuestas = (page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await getLinksEncuestasService(page, status);
    if (result && result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startGetLinksEncuestasBySearch = (
  term: string,
  page: number = 1,
  status?: number
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await getLinksEncuestasBySearchService(term, page, status);
    if (result && result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startCreateLinkEncuesta = (data: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await createLinkEncuestaService(data);

    if (result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startGetLinkEncuestaDetail = (id: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await getLinkEncuestaDetailService(id);
    if (result && result.ok) {
      await dispatch(storeLinkEncuestaDetailRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startUpdateLinkEncuesta = (id: string, data: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await updateLinkEncuestaService(id, data);
    if (result && result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startDesactiveLinkEncuesta = (
  id: string,
  term: string = '',
  page: number = 1,
  status?: number
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await deleteLinkEncuestaService(id, term, page, status);
    if (result && result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
      if (result.data.shareTemplates)
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};

export const startActiveLinkEncuesta = (
  id: string,
  term: string = '',
  page: number = 1,
  status?: number
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    const result = await restoreLinkEncuestaService(id, term, page, status);
    if (result && result.ok) {
      await dispatch(setLinksEncuestasRedux(result.data));
      await dispatch(setLinksSurveysForSelect(result.data.surveys));
      await dispatch(setLinksUsersForSelect(result.data.users));
    }
    dispatch(unCheckingPreload());
    return result;
  };
};
